"use strict";

import React from "react";

import {
  Puzzle,
  PuzzlePiece,
  PositionedPiece,
  PUZZLE_CONFIG,
} from "./puzzle.js";
import { CrayonBox, CrayonScribble, PositionedScribble } from "./crayon.js";
import { PRODUCT_KEYS as S } from "./data_helpers.js";
import { scoreIsMissing } from "./shared.js";

export function OverallGraphicRep({ survey, size = 250, ...props }) {
  const REPS_BY_PRODUCT = {
    [S.ECE]: CrayonBox,
    [S._5E]: Puzzle,
  };
  let Rep = REPS_BY_PRODUCT[survey.product];
  if (!Rep)
    throw Error(
      `No overall graphic representation configured for survey of type: '${
        survey && survey.product
      }'`,
    );
  return <Rep survey={survey} size={size} {...props} />;
}

export function IndividualGraphicRep({ survey, item, size = 25, ...props }) {
  const REPS_BY_PRODUCT = {
    [S.ECE]: CrayonScribble,
    [S._5E]: PuzzlePiece,
  };
  // NOTE: even for ECE surveys, we retain the original (5E) rep for measures and pseudo-essentials like '_supplemental'
  let Rep =
    item._level === "measures" || item._alias
      ? REPS_BY_PRODUCT[S._5E]
      : REPS_BY_PRODUCT[survey.product];
  if (!Rep)
    throw Error(
      `No individual graphic representation configured for survey of type: '${
        survey && survey.product
      }'`,
    );
  return <Rep {...{ survey, item, size }} {...props} />;
}

export function IndividualRepMarker({
  survey,
  item,
  result,
  x,
  yScale,
  alwaysDisplay = false,
  ...props
}) {
  const REPS_BY_PRODUCT = {
    [S.ECE]: PositionedScribble,
    [S._5E]: PositionedPiece,
  };
  // NOTE: even for ECE surveys, we retain the original (5E) rep for measures and pseudo-essentials like '_supplemental'
  let Rep =
    item._level === "measures" || item._alias
      ? REPS_BY_PRODUCT[S._5E]
      : REPS_BY_PRODUCT[survey.product];
  if (!Rep)
    throw Error(
      `No individual marker representation configured for survey of type: '${
        survey && survey.product
      }'`,
    );

  let SS = survey.product_key === S.ECE ? 50 : 15; // "survey size"
  let OS = PUZZLE_CONFIG.sideLen; // "original size"

  if (scoreIsMissing(result) && !alwaysDisplay) return null;

  let y = yScale(result.score);
  return (
    <g
      className={
        Rep === PositionedPiece
          ? `puzzle-marker rank-${result.code}-ring`
          : `scribble-marker`
      }
      transform={`translate(${x},${y}) scale(${SS / OS}) translate(${-OS / 2},${
        -OS / 2
      })`}
    >
      <Rep {...{ survey, item, result }} {...props} />
    </g>
  );
}
